import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/global.css'
import $ from 'jquery'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'

import VueAwesomeSwiper from 'vue-awesome-swiper'
//引入nprogress
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' //这个样式必须引入
// import style
import 'swiper/swiper-bundle.min.css'

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
Vue.prototype.$axios = axios
axios.defaults.baseURL = 'http://huize.yuandacloud.com:8002/api'  //关键代码
Vue.config.productionTip = false
import { Button, Message } from 'element-ui';
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

axios.create({
  headers: { "Content-Type": "application/json;charset=utf-8",
    "Access-Control-Allow-Credentials": '*'}, //即将被发送的自定义请求头
  withCredentials: true //表示跨域请求时是否需要使用凭证

})
axios.interceptors.response.use(
    response => {
      /**请求成功处理 */
      if (response.data) {
        /**这里根据后端提供的数据进行对应的处理 */
        return response.data
      } else {
        if(response.status==204){
          Message({
            message: '成功了',
            type: 'success'
          })
          return 1;
        }
      }
    },
    /**响应错误处理 */
    error => {
      if (error && error.response) {
        console.log(error.response,"err")
        switch (error.response.status) {
          case 400:
            error.message = '请求错误'
            break
          case 401:
            error.message = error.response.data.error;
            break
          case 403:
            error.message = '拒绝访问'
            break
          case 404:
            error.message = error.response.data.error;
            break
          case 408:
            error.message = '请求超时'
            break
          case 422:
            error.message = error.response.data.message;
            break
          case 429:
            error.message =error.response.data.message;
            break
          case 500:
            error.message = '服务器出错了,请刷新重试'
            break
          case 501:
            error.message = '服务未实现'
            break
          case 502:
            error.message = '网关错误'
            break
          case 503:
            error.message = '服务不可用'
            break
          case 504:
            error.message = '网关超时'
            break
          case 505:
            error.message = 'HTTP版本不受支持'
            break
          default:
            break
        }
      }
      Message({
        message: error.response.data.message,
        type: 'error'
      })
      return Promise.reject(error)
    }
)
//中英文切换
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem('languageSet') || 'zh',   //从localStorage里获取用户中英文选择，没有则默认中文
  messages: {
    'zh': require('../src/language/zh'),
    'en': require('../src/language/en')
  }
})

//element ui
import {
  Drawer, Table,
  TableColumn, Carousel,
  CarouselItem, Image,
} from "element-ui";
Vue.use(Drawer);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Image);
// Vue.use(Message)
Vue.prototype.$message = Message;
// 简单配置加载进度条
NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })


router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})


//路由跳转后定到页面顶部
router.afterEach(route => {
  window.scrollTo(0, 0)
  NProgress.done()

})

//头部尾部
import Header from './components/Header.vue'
Vue.component('Header', Header)
import Footer from './components/Footer.vue'
Vue.component('Footer', Footer)

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App),
  mounted() {
    document.title = '西安惠泽建设工程有限公司';
  }
  
}).$mount('#app')

